import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, ref, onBeforeUnmount, inject } from "vue";
import { UIModal, UIModalHeader, UIModalFooter, useNotification, } from "@gohighlevel/ghl-ui";
import { useMainStore } from "@/store/main";
import PaymentLinkService from "@/services/PaymentLinksService";
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DeleteModal',
    props: {
        getPaymentLinks: {
            type: Function,
            required: true
        },
    },
    setup(__props) {
        const { t } = useI18n();
        const eventBus = inject('emitter');
        const store = useMainStore();
        const notification = useNotification();
        const loading = ref(false);
        const showModal = ref(false);
        const paymentlink = ref();
        const props = __props;
        onMounted(() => {
            eventBus.on("open-paymentlinks-delete-modal", (data) => {
                paymentlink.value = data;
                showModal.value = true;
            });
        });
        onBeforeUnmount(() => {
            eventBus.off("open-paymentlinks-delete-modal");
        });
        function cancelCallback() {
            if (loading.value)
                return;
            showModal.value = false;
        }
        const submitCallback = async () => {
            if (loading.value)
                return;
            try {
                loading.value = true;
                const { data } = await PaymentLinkService.deletePaymentLink(paymentlink.value._id, {
                    altId: paymentlink.value.altId,
                    altType: paymentlink.value.altType
                });
                props.getPaymentLinks();
                showModal.value = false;
                notification.success({
                    content: t('dashboard.paymentlinkDeletedSuccessfully'),
                    duration: 5000,
                    keepAliveOnHover: true
                });
            }
            catch (error) {
                let errorMsg = error?.response?.data?.message ||
                    error?.message ||
                    t("dashboard.paymentlinkDeletionError");
                if (Array.isArray(errorMsg))
                    errorMsg = errorMsg.join(", ");
                notification.error({
                    content: errorMsg,
                    duration: 3000,
                    keepAliveOnHover: true,
                });
            }
            finally {
                loading.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: showModal.value,
                "onUpdate:show": _cache[0] || (_cache[0] = ($event) => ((showModal).value = $event))
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        type: "warning",
                        title: _ctx.$t('dashboard.deletePaymentLinkTitle'),
                        description: _ctx.$t('dashboard.deletePaymentLinkDescription'),
                        onClose: cancelCallback,
                        id: "delete-paymentlink-modal-header"
                    }, null, 8 /* PROPS */, ["title", "description"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        positiveText: _ctx.$t('common.delete'),
                        negativeText: _ctx.$t('common.cancel'),
                        onPositiveClick: submitCallback,
                        onNegativeClick: cancelCallback,
                        loading: loading.value,
                        disabled: loading.value,
                        id: "delete-paymentlink-modal-footer"
                    }, null, 8 /* PROPS */, ["positiveText", "negativeText", "loading", "disabled"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
